export function openInNewTab(url: string) {
  // @ts-ignore
  window.open(url, "_blank").focus();
}
